exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".HorizontalSlider{width:100%;height:100%}.HorizontalSlider img{width:100%}.HorizontalSlider .HorizontalSlider-container{height:100%;z-index:0}.HorizontalSlider .HorizontalSlider-container .swiper-wrapper{z-index:0}.HorizontalSlider .slider-image{height:100%;background-size:cover;background-repeat:no-repeat;background-position:50%}.swiper-slide{text-align:center}.swiper-slide img{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-448c396a","scoped":false,"hasInlineConfig":false}!/~/sass-loader/lib/loader.js!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/components/HorizontalSlider.vue
// module id = 393
// module chunks = 0